import React, { FC, ReactElement } from 'react';
import { Query } from '@apollo/client/react/components';

import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import JobApplicationShowPage from 'buyside/components/presentation/JobApplicationShowPage/jobApplicationShowPage';

import {
  JobPostingAndApplicationDocument,
  JobPostingAndApplicationQueryVariables,
  JobPostingAndApplicationQuery
} from 'interfaces/graphql-typings';

const JobApplicationShowPageContainer: FC<{
  jobApplicationId: string;
}> = ({ jobApplicationId }): ReactElement => (
  <Query<JobPostingAndApplicationQuery, JobPostingAndApplicationQueryVariables>
    query={JobPostingAndApplicationDocument}
    variables={{ jobApplicationId }}
  >
    {({ loading, error, data }): ReactElement => {
      if (loading || !data || !data.jobApplication) return <LoadingSpinner size="large" />;
      if (error) throw error;

      return <JobApplicationShowPage jobApplication={data.jobApplication} />;
    }}
  </Query>
);

export default JobApplicationShowPageContainer;
